// CSS
import './LoadingScreenOverlay.css';
// React hooks
import { useState, useEffect } from 'react';


// ====================
// LoadingScreenOverlay - the Loading Screen used as a placehold whilst processing info on Product Pages.
// ====================
function LoadingScreenOverlay({ 
    messagesToDisplay,              // String[] – the loading messages to display
    estimatedTimeMilliseconds,      // int      – the amount of time (in milliseconds) to display this loading screen
    currentActionMessage,           // String   – the primary action message to display
    optionalActionMessage,          // String   – the optional action message to display
    isLoadingBarFull,               // bool     – is the loading bar already finished?
 }){
    
    // Edge case: "messagesToDisplay" undefined
    if (!messagesToDisplay) {
        messagesToDisplay = ["Loading"];
    }

    // Edge case: "estimatedTimeMilliseconds" undefined OR too-short for smooth loading
    if (!estimatedTimeMilliseconds || estimatedTimeMilliseconds < 501) {
        estimatedTimeMilliseconds = 0;
    } else {
        // Design: Loading Screen finishes progress slightly before being disabled
        estimatedTimeMilliseconds -= 500;
    }

    // Cycle through all messagesToDisplay during the loading process
    const [currDisplayedMessageIndex, setCurrDisplayedMessageIndex] = useState(0);
    useEffect(() => {
        // Edge case: Empty []
        if (!messagesToDisplay?.length) return;

        // Calculate the time per message
        const timePerMessage = estimatedTimeMilliseconds / messagesToDisplay.length;

        // Vibe-coded function to cycle through messages
        const interval = setInterval(() => {
            setCurrDisplayedMessageIndex((prev) => {
                if (prev >= messagesToDisplay.length - 1) {
                    clearInterval(interval);
                    return prev;
                } else {
                    return prev + 1;
                }});
        }, timePerMessage);

        return () => clearInterval(interval);
    }, [messagesToDisplay, estimatedTimeMilliseconds]);

    
    // =============
    // JSX Component
    // =============
    return (
        <div className='LoadingScreenOverlay'>

            {/* Action message */}
            <div className='LoadingScreenOverlay-current-action-message'>{currentActionMessage}</div>

            {/* Optional action message */}
            { optionalActionMessage && <div className='LoadingScreenOverlay-optional-action-message'>{optionalActionMessage}</div>}
                
            {/* Messages to display */}
            <div className='LoadingScreenOverlay-displayed-message'>{messagesToDisplay[currDisplayedMessageIndex]}...</div>

            {/* Macbook-inspired loading bar */}
            
            {/* CONDITION: Loading NOT finished */}
            { !isLoadingBarFull &&
                <div className="macos-loading-bar-container">
                    <div className="macos-loading-bar-progress" style={{animationDuration: `${estimatedTimeMilliseconds}ms`,}}></div>
                </div>
            }

            {/* CONDITION: Loading finished */}
            { isLoadingBarFull &&
                <div className="macos-loading-bar-container">
                    <div className="macos-loading-bar-progress" style={{animationDuration: `0ms`,}}></div>
                </div>
            }
        </div>
    );
};


// Export statement
export default LoadingScreenOverlay;